import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../../../reducers';
import { Tooltip } from '@mui/material';
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';
import { determinarAMoPM } from '../../../../utils/strings.utils';
import EditIcon from '../../../../media/felsv/DarkEditPencil.svg';
import { gu_hs_onSelectSucursal, setSelectedSucursal } from '../../../../actions/gestion-usuario/horarios/horarios.actions';

export const SucursalHorarioList = () => {
  const {dataSucursales, dataEmpresa} = useSelector((state: State) => state.horarios);
  const [currentItemsTable, setCurrentItemsTable] = useState<Array<any>>([]);
  const [filteredData, setSortedDataTable] = useState<Array<any>>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setSortedDataTable(dataSucursales);
    dispatch(setSelectedSucursal(null));
  }, [dataSucursales]);

  const getHorario = (sucursal: any) => {
    var strHorario = "Sin limitación de horario";
    const horarioSucursal = sucursal.SucursalHorarios[0];
    if (horarioSucursal) {
      if (horarioSucursal.hora_inicio && horarioSucursal.hora_final) {
        return `${horarioSucursal.hora_inicio}${determinarAMoPM(horarioSucursal.hora_inicio)} - ${horarioSucursal.hora_final}${determinarAMoPM(horarioSucursal.hora_final)}`
      }
    }
    return strHorario;
  }

  return (
    <>
      {dataEmpresa && 
      (
        <div className='container-white w-100'>
          <div className='client-tab-title'>
            <h3 className='card-title mb-16'>Sucursales</h3>
          </div>
          <div className='table-responsive-container mt-16'>
            <div style={{fontSize: '12px'}} className='tab-plane'>
              <table className='table-main-responsive responsive-table-main td-left table-pointer'>
                <thead>
                  <tr>
                    <td>Acciones</td>
                    <td>Nombre de sucursal <FilterButton data={filteredData} keyName='nombre' state={(items: Array<any>) => setSortedDataTable(items)}/></td>
                    <td>Dirección <FilterButton data={filteredData} keyName='codigo' state={(items: Array<any>) => setSortedDataTable(items)}/></td>
                    <td>Horario</td>
                  </tr>
                </thead>
                <tbody>
                    {filteredData.length === 0 &&
                      <tr>
                        <td colSpan={10}>
                          <div className='empty-table-message'>Sin datos disponibles.</div>
                        </td>
                      </tr>
                    }
                    {
                      filteredData.length > 0 && currentItemsTable.map((row:any, index:number) => (
                        <tr key={index}>
                          <td data-label = 'Acciones' className='table-td'>
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                              <Tooltip title='Editar horario' arrow>
                                <button onClick={() => dispatch(gu_hs_onSelectSucursal(row))} className='table-action'>
                                  <img alt='Edit schedule' className='table-img-action' style={{height: '14px', width: '14px', borderRadius: '100px'}} src={EditIcon}/>
                                </button>
                              </Tooltip>
                            </div>
                          </td>
                          <td data-label='Nombre de sucursal'>{row.nombre}</td>
                          <td data-label='Dirección'>{row.direccion}</td>
                          <td data-label='Horario'>{getHorario(row)}</td>
                        </tr>
                      ))
                    }
                </tbody>
            </table>
            </div>
          </div>
          <Pagination data = {filteredData} state = {(items: Array<any>) => setCurrentItemsTable(items)} items = {5}/>
        </div>
      )}
    </>   
  )
}